
export default function behavior(label, action) {
  // 使用百度统计，统计页面中的用户行为
  // index.html模板文件中需要先预定于 var _hmt = _hmt || [];
  // eslint-disable-next-line
  window._hmt && window._hmt.push(['_trackEvent', '送球鞋', action, label])
  window._sdkLog && window._sdkLog.push(['_trackEventWithoutB', '送球鞋', action, label])
}
